export function preparePropertyComparer(context) {
  return function isPropertyChanged(propName, prevProps) {
    return context.props[propName] !== prevProps[propName];
  };
}
